export default __webpack_public_path__ + "static/media/hero-image.97dd95b5.png";